import { ClientConfigResponse } from "services/partnerCenterService";

class Settings {
    public clientId?: string;
    public authority?: string;
    public knownAuthorities?: string[];
    public isProduction?: boolean;

    public setSettings(clientConfig: ClientConfigResponse) {
        this.clientId = clientConfig.clientId;
        this.authority = `${clientConfig.instanceUrl}/${clientConfig.b2CDomain}/${clientConfig.signInPolicy}`;
        this.knownAuthorities = [clientConfig.instanceUrl];
        this.isProduction = clientConfig.production;
    }
}

export const settings = new Settings();